import { render, staticRenderFns } from "./SupplierSurveyFeedback.vue?vue&type=template&id=3c01858b&scoped=true&"
import script from "./SupplierSurveyFeedback.vue?vue&type=script&lang=js&"
export * from "./SupplierSurveyFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c01858b",
  null
  
)

export default component.exports